<template>
  <div
      class="loginContainer"
      style="">
    <Login-component />
  </div>

</template>

<script>

import LoginComponent from "../../../components/b2b/hyundai/LoginComponent";

export default {
  name: "hyundaiLogin.vue",
  components: {LoginComponent}
}
</script>

<style scoped>
.loginContainer {
  font-family: 'HDharmony', sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #D2D2D2;
}

</style>
